<script setup lang="ts">
import { AppButton, AppFormHeader } from '@/components/base';

withDefaults(
  defineProps<{
    title?: string;

    showHeader?: boolean;
    isOnboarding?: boolean;
  }>(),
  {
    title: 'Terms of Use',

    showHeader: false,
    isOnboarding: true,
  }
);

const emits = defineEmits<{
  (e: 'next'): void;
}>();

const router = useRouter();
const { data, pending, execute } = useGetData();

const html = computed((): string => {
  return data.value || '';
});

const fetch = async (): Promise<void> => {
  await execute('/pages/terms_of_use');
};

const next = (): void => {
  emits('next');
};

const back = (): void => {
  router.back();
};

onMounted(() => {
  fetch();
});
</script>
<template>
  <div class="terms-and-conditions">
    <div class="terms-and-conditions__header">
      <AppTypography class="terms-and-conditions__title">{{ title }}</AppTypography>
      <AppButton variant="text" color="primary" class="terms-and-conditions__close-btn" @click="back()">
        <v-icon>mdi-chevron-left</v-icon>Back
      </AppButton>
    </div>
    <template v-if="!pending">
      <div v-html="html" class="mb-10" />
    </template>
    <template v-else>
      <v-skeleton-loader type="article" />
      <v-skeleton-loader type="paragraph" />
      <v-skeleton-loader type="paragraph" />
    </template>
    <!-- <template v-if="isOnboarding">
      <AppButton color="primary" block class="terms-and-conditions__save mt-6 mb-5" @click="next()">Continue</AppButton>
    </template>
    <template v-else>
      <AppButton color="primary" block class="terms-and-conditions__back mt-6 mb-5" @click="back()">Back</AppButton>
    </template> -->
  </div>
</template>
<style lang="scss" scoped>
.terms-and-conditions {
  width: 100%;
  max-width: 896px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-sizing: border-box;
  max-height: 80vh;
  overflow-y: auto;

  &__header {
    width: 100%;
    margin-bottom: 24px;
  }

  &__title {
    font-weight: bold;
  }

  &__close-btn {
    cursor: pointer;
    font-size: 20px;
    color: #333;
    
    &:hover {
      color: #666;
    }
  }

  .terms-and-conditions__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .terms-and-conditions__title {
    font-size: 20px;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    max-width: 95vw;
    padding: 16px 8px;
    font-size: 0.95rem;
    max-height: 80vh;
  }
}
</style>
